module.exports = __webpack_public_path__ + "6b259d72c1ca2f81c42d31ab35b3b6b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/8.jpg
// module id = 291
// module chunks = 0